import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './components/map/map.component';
import { NgxMapLibreGLModule } from '@maplibre/ngx-maplibre-gl';
import { MapMarkerBaseIconComponent } from './components/map-marker-icon/map-marker-base-icon.component';
import { PopupContentDirective } from './directives/popup-content.directive';
import { MapSidebarItemsComponent } from './components/map-sidebar-items/map-sidebar-items.component';
import { MapSidebarListItemComponent } from './components/map-sidebar-list-item/map-sidebar-list-item.component';
import { MapMarkerWithPopupComponent } from './components/map-marker-with-popup/map-marker-with-popup.component';
import { MapWithSidebarComponent } from './components/map-with-sidebar/map-with-sidebar.component';
import { MapSidebarComponent } from './components/map-sidebar/map-sidebar.component';
import { MapItemIconComponent } from './components/map-item-icon/map-item-icon.component';
import { FullPageOverlayComponent, IconComponent } from '@ui/shared/ui-common';
import { FiltersDirective } from './directives/filters.directive';
import { MinimizeSidebarButtonComponent } from './components/minimize-sidebar-button/minimize-sidebar-button.component';
import { MaximizeSidebarButtonComponent } from './components/maximize-sidebar-button/maximize-sidebar-button.component';
import { SidebarItemDisplayToggleComponent } from './components/sidebar-item-display-toggle/sidebar-item-display-toggle.component';
import { MapSidebarRasterItemComponent } from './components/map-sidebar-raster-item/map-sidebar-raster-item.component';
import {
    MaximizeMapWithSidebarButtonComponent,
} from './components/maximize-map-with-sidebar-button/maximize-map-with-sidebar-button.component';
import {
    MinimizeMapWithSidebarButtonComponent,
} from './components/minimize-map-with-sidebar-button/minimize-map-with-sidebar-button.component';
import { ShowMapButtonComponent } from './components/show-map-button/show-map-button.component';
import { ShowMapItemsButtonComponent } from './components/show-map-items-button/show-map-items-button.component';
import { MapSidebarItemsSkeletonComponent } from './components/map-sidebar-items-skeleton/map-sidebar-skeleton.component';
import { SkeletonModule } from 'primeng/skeleton';
import { MapButtonComponent } from './components/map-button/map-button.component';
import { MapMarkerAreaIconComponent } from './components/map-marker-area-icon/map-marker-area-icon.component';
import { ButtonDirective, ButtonLabel } from 'primeng/button';
import { FocusTrap } from 'primeng/focustrap';
import { AutoFocus } from 'primeng/autofocus';

@NgModule({
    declarations: [
        MapComponent,
        MapMarkerBaseIconComponent,
        MapMarkerAreaIconComponent,
        MapSidebarItemsComponent,
        MapSidebarItemsSkeletonComponent,
        MapSidebarListItemComponent,
        MapMarkerWithPopupComponent,
        PopupContentDirective,
        FiltersDirective,
        MapWithSidebarComponent,
        MapSidebarComponent,
        MapButtonComponent,
        MinimizeSidebarButtonComponent,
        MaximizeSidebarButtonComponent,
        SidebarItemDisplayToggleComponent,
        MapSidebarRasterItemComponent,
        MaximizeMapWithSidebarButtonComponent,
        MinimizeMapWithSidebarButtonComponent,
        ShowMapButtonComponent,
        ShowMapItemsButtonComponent,
    ],
    imports: [
        CommonModule,

        NgxMapLibreGLModule,
        SkeletonModule,

        IconComponent,
        MapItemIconComponent,
        FullPageOverlayComponent,
        ButtonDirective,
        ButtonLabel,
        FocusTrap,
        AutoFocus,
    ],
    exports: [
        MapWithSidebarComponent,
    ],
})
export class MapWithSidebarModule {
}
